import { render, staticRenderFns } from "./DashboardCardTenants.vue?vue&type=template&id=918d1a52&"
import script from "./DashboardCardTenants.vue?vue&type=script&lang=js&"
export * from "./DashboardCardTenants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports